import { IBorderRadiusData, IFontData, IInteractiveElementColorData, SelfPosition } from "@pageBuilder/typings";

export interface IMembersAreaWidgetContainerStyle {
    linkColor: IInteractiveElementColorData;
    backgroundColor: string;
    borderRadius?: IBorderRadiusData | null;
    font: IFontData;
    padding: number;
    textAlign: SelfPosition;
}

export abstract class MembersAreaWidgetContainerStyle {

    public static get defaultStyle(): IMembersAreaWidgetContainerStyle {
        return {
            linkColor: {
                colorDefault: "#0E7BC4",
                colorHovered: "#12A3F8",
                colorClicked: "#12A3F8"
            },
            backgroundColor: "#FFFFFF",
            borderRadius: {
                topLeftPx: 12,
                topRightPx: 12,
                bottomLeftPx: 12,
                bottomRightPx: 12
            },
            font: {
                family: "",
                weight: "",
                size: "",
                lineHeight: ""
            },
            padding: 0,
            textAlign: "center"
        };
    }

}